"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("./es6Promise"),require("./objectAssign"),require("./objectKeys");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/lib/polyfills/index.js
// module id = 1119
// module chunks = 106